export const initialState = {
  movetoactivationpage: false,
  movetopaymentpage: false,
  movetotermspage: false,
  movetoconfirmpage: false,
  shownavigationthroughtopbar: true,
  servicerules: {},
  countries: [],
  states: [],
  timezone: [],
  serviceProvider: [],
  servicePlan: [],
  servicePlanGPS: [],
  discount_quarter: "",
  discount_yearly: "",
  vehicle_colors: [
    { text: "black", value: "#000" },
    { text: "blue1", value: "#235fa6" },
    { text: "blue2", value: "#3f85d6" },
    { text: "blue3", value: "#2929af" },
    { text: "bluegrey", value: "#6f7d8e" },
    { text: "green1", value: "#078605" },
    { text: "green2", value: "#3bce1c" },
    { text: "green3", value: "#64d63f" },
    { text: "grey1", value: "#ababab" },
    { text: "grey2", value: "#535353" },
    { text: "orange1", value: "#cc6612" },
    { text: "pink", value: "#e83ade" },
    { text: "purple", value: "#7c077e" },
    { text: "red1", value: "#a60002" },
    { text: "red2", value: "#cc1214" },
    { text: "red3", value: "#d43a3b" },
    { text: "skyblue", value: "#2faca9" },
    { text: "violet", value: "#793ab8" },
    { text: "white", value: "#fff" },
    { text: "yellow2", value: "#cec81c" },
    { text: "yellow3", value: "#c8d63f" },
    { text: "yellow1", value: "#b5b700" },
  ],
  vehicle_colors_obj2: {
    0: { text: "black", value: "#000", id: 0 },
    1: { text: "blue1", value: "#235fa6", id: 1 },
    2: { text: "blue2", value: "#3f85d6", id: 2 },
    3: { text: "blue3", value: "#2929af", id: 3 },
    4: { text: "bluegrey", value: "#6f7d8e", id: 4 },
    5: { text: "green1", value: "#078605", id: 5 },
    6: { text: "green2", value: "#3bce1c", id: 6 },
    7: { text: "green3", value: "#64d63f", id: 7 },
    8: { text: "grey1", value: "#ababab", id: 8 },
    9: { text: "grey2", value: "#535353", id: 9 },
    10: { text: "orange1", value: "#cc6612", id: 10 },
    11: { text: "pink", value: "#e83ade", id: 11 },
    12: { text: "purple", value: "#7c077e", id: 12 },
    13: { text: "red1", value: "#a60002", id: 13 },
    14: { text: "red2", value: "#cc1214", id: 14 },
    15: { text: "red3", value: "#d43a3b", id: 15 },
    16: { text: "skyblue", value: "#2faca9", id: 16 },
    17: { text: "violet", value: "#793ab8", id: 17 },
    18: { text: "white", value: "#fff", id: 18 },
    19: { text: "yellow2", value: "#cec81c", id: 19 },
    20: { text: "yellow3", value: "#c8d63f", id: 20 },
    21: { text: "yellow1", value: "#b5b700", id: 21 },
  },
  vehicleimages: [
    { length: new Array(21).fill(0), value: "car" },
    { length: new Array(21).fill(0), value: "marker" },
    { length: new Array(21).fill(0), value: "minitruck" },
    { length: new Array(21).fill(0), value: "bus" },
    { length: new Array(21).fill(0), value: "minibus" },
    { length: new Array(7).fill(0), value: "truck" },
  ],
  backupCustomerInformation: {
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    serviceProvider: "",
    customserviceProvider: "",
    phone: "",
    companyName: "",
    billingAddress: "",
    country: "United States",
    city: "",
    state: "",
    zipcode: "",
    timezone: "",
    timezonedescription: "",
    emailverified: false,
    shownextstep: false,
  },
  backupactivationType: {
    gpsdevices: "1",
    devices: [
      {
        imei: "",
        device_name: "",
        device_model: "",
        error: false,
        servicePlan: "",
        plantype: "plus_quarterly",
        plantypeobd: "plus_obd_quarterly",
        category: "",
        price: "",
        plan_name: "",
      },
    ],
    // servicePlan: "",
    unit: "",
  },
  backuppaymentMethod: {
    cardHoldername: "",
    cardnumber: "",
    cvc: "",
    expirationdatemonth: "",
    expirationdateyear: "",
    token: "",
    bin: "",
    last_4: "",
  },
  customerInformation: {
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    serviceProvider: "",
    customserviceProvider: "",
    phone: "",
    companyName: "",
    billingAddress: "",
    country: "United States",
    city: "",
    state: "",
    zipcode: "",
    timezone: "",
    timezonedescription: "",
    emailverified: false,
    shownextstep: false,
  },
  activationType: {
    gpsdevices: "1",
    devices: [
      {
        imei: "",
        device_name: "",
        device_model: "",
        error: false,
        errormessage: "",
        servicePlan: "",
        plantype: "plus_quarterly",
        plantypeobd: "plus_obd_quarterly",
        category: "",
        price: "",
        plan_name: "",
      },
    ],
    // servicePlan: "",
    unit: "",
  },
  paymentMethod: {
    cardHoldername: "",
    cardnumber: "",
    cvc: "",
    expirationdatemonth: "",
    expirationdateyear: "",
    token: "",
    bin: "",
    last_4: "",
  },
  terms: {
    checked: false,
  },
  userexists: false,
  globalalert: true,
  devicesetting: {
    attach_dettach_email: false,
    attach_dettach_notification: true,
    attach_dettach_notification_global: true,
    attach_dettach_sms: true,
    battery_email: false,
    battery_low_limit: "",
    battery_notification: true,
    battery_notification_global: true,
    battery_sms: false,
    charging_email: false,
    charging_notification: true,
    charging_notification_global: true,
    charging_sms: false,
    crash_acceleration_email: false,
    crash_acceleration_notification: false,
    crash_acceleration_sms: false,
    crash_acceleration_notification_global: false,
    threshold_x: 0,
    threshold_y: 0,
    threshold_z: 0,
    samples_after_crash: 0,
    samples_before_crash: 0,
    customer_id: "",
    device_frequency_value: "",
    device_name: "",
    device_reporting_frequency: null,
    device_reporting_frequency_desc: "",
    email: "",
    engine_email: true,
    engine_notification: true,
    engine_notification_global: true,
    engine_sms: true,
    fuel_capacity: "",
    fuel_capacity_unit: "",
    global_email: true,
    global_notification: true,
    global_sms: true,
    harsh_notification_global: true,
    harshacceleration_email: true,
    harshacceleration_notification: true,
    harshacceleration_sms: true,
    harshbraking_email: true,
    harshbraking_notification: true,
    harshbraking_sms: true,
    harshturning_email: true,
    harshturning_notification: true,
    harshturning_sms: true,
    high_speed: 0,
    high_speed_breaking: 0,
    high_speed_acceleration: 0,
    medium_speed: 0,
    medium_speed_breaking: 0,
    medium_speed_acceleration: 0,
    low_speed_braking: 0,
    low_speed_acceleration: 0,
    corner_braking_thershold: 0,
    corner_braking_duration: 0,
    acceleration_thershold: 0,
    acceleration_duration: 0,
    id: "",
    imei: "",
    mobile_carrier: "",
    phone: "",
    power_email: false,
    power_notification: true,
    power_notification_global: true,
    power_sms: false,
    secondary_mobile_carrier: "",
    secondary_phone: null,
    show_battery: true,
    show_engine_load: true,
    show_engine_rpm: true,
    show_engine_temp: true,
    show_fuel_consumption: true,
    show_fuel_level: true,
    show_location: true,
    show_mileage: true,
    show_speed: true,
    show_throttle_position: true,
    show_voltage: true,
    sos_email: false,
    sos_notification: true,
    sos_notification_global: true,
    sos_sms: false,
    speed_email: true,
    speed_limit: "",
    speed_notification: true,
    speed_notification_global: true,
    speed_sms: true,
    tow_email: true,
    tow_notification: true,
    tow_notification_global: true,
    tow_sms: true,
    warning_email: true,
    warning_notification: true,
    warning_notification_global: true,
    warning_sms: true,
    trip_coordinate: true,
    trip_email: false,
    trip_end_timer: "",
    trip_notification: false,
    trip_notification_global: true,
    trip_sensor: false,
    trip_sms: false,
    vehicle_color: "grey1",
    vehicle_type: "car",
    zone_alert_notification: true,
  },
  devicesettinggps: {
    device_name: "",
    trip_notification: false,
    trip_email: false,
    trip_sms: false,
    engine_notification: false,
    engine_email: false,
    speed_limit: 0,
    speed_notification: false,
    speed_sms: false,
    speed_email: false,
    power_notification: false,
    power_sms: false,
    power_email: false,
    show_speed: false,
    show_mileage: false,
    show_voltage: false,
    show_location: false,
    show_fuel_level: false,
    vehicle_color: "green3",
    vehicle_type: "marker",
    battery_notification: false,
    battery_email: false,
    battery_low_limit: 0,
    battery_sms: false,
    sos_notification: false,
    sos_email: false,
    sos_sms: false,
    charging_notification: false,
    charging_email: false,
    charging_sms: false,
    trip_end_timer: 0,
    global_email: false,
    global_sms: false,
    global_notification: false,
    email: "",
    phone: "",
    secondary_phone: "",
    trip_notification_global: false,
    speed_notification_global: false,
    power_notification_global: false,
    battery_notification_global: false,
    sos_notification_global: false,
    charging_notification_global: false,
    mobile_carrier: "",
    secondary_mobile_carrier: "",
    trip_sensor: false,
    trip_coordinate: false,
  },
  bkpdevicesettinggps: {
    device_name: "",
    trip_notification: false,
    trip_email: false,
    trip_sms: false,
    engine_notification: false,
    engine_email: false,
    speed_limit: 0,
    speed_notification: false,
    speed_sms: false,
    speed_email: false,
    power_notification: false,
    power_sms: false,
    power_email: false,
    show_speed: false,
    show_mileage: false,
    show_voltage: false,
    show_location: false,
    show_fuel_level: false,
    vehicle_color: "green3",
    vehicle_type: "marker",
    battery_notification: false,
    battery_email: false,
    battery_low_limit: false,
    battery_sms: false,
    sos_notification: false,
    sos_email: false,
    sos_sms: false,
    charging_notification: false,
    charging_email: false,
    charging_sms: false,
    trip_end_timer: 0,
    global_email: false,
    global_sms: false,
    global_notification: false,
    email: "",
    phone: "",
    secondary_phone: "",
    trip_notification_global: false,
    speed_notification_global: false,
    power_notification_global: false,
    battery_notification_global: false,
    sos_notification_global: false,
    charging_notification_global: false,
    mobile_carrier: "",
    secondary_mobile_carrier: "",
    trip_sensor: false,
    trip_coordinate: false,
  },
  backupdevicesetting: {
    attach_dettach_email: false,
    attach_dettach_notification: true,
    attach_dettach_notification_global: true,
    attach_dettach_sms: true,
    battery_email: false,
    battery_low_limit: "",
    battery_notification: true,
    battery_notification_global: true,
    battery_sms: false,
    charging_email: false,
    charging_notification: true,
    charging_notification_global: true,
    charging_sms: false,
    crash_acceleration_email: false,
    crash_acceleration_notification: false,
    crash_acceleration_sms: false,
    crash_acceleration_notification_global: false,
    threshold_x: 0,
    threshold_y: 0,
    threshold_z: 0,
    samples_after_crash: 0,
    samples_before_crash: 0,
    customer_id: "",
    device_frequency_value: "",
    device_name: "",
    device_reporting_frequency: null,
    device_reporting_frequency_desc: "",
    email: "",
    engine_email: true,
    engine_notification: true,
    engine_notification_global: true,
    engine_sms: true,
    fuel_capacity: "",
    fuel_capacity_unit: "",
    global_email: true,
    global_notification: true,
    global_sms: true,
    harsh_notification_global: true,
    harshacceleration_email: true,
    harshacceleration_notification: true,
    harshacceleration_sms: true,
    harshbraking_email: true,
    harshbraking_notification: true,
    harshbraking_sms: true,
    harshturning_email: true,
    harshturning_notification: true,
    harshturning_sms: true,
    high_speed: 0,
    high_speed_breaking: 0,
    high_speed_acceleration: 0,
    medium_speed: 0,
    medium_speed_breaking: 0,
    medium_speed_acceleration: 0,
    low_speed_braking: 0,
    low_speed_acceleration: 0,
    corner_braking_thershold: 0,
    corner_braking_duration: 0,
    acceleration_thershold: 0,
    acceleration_duration: 0,
    id: "",
    imei: "",
    mobile_carrier: "",
    phone: "",
    power_email: false,
    power_notification: true,
    power_notification_global: true,
    power_sms: false,
    secondary_mobile_carrier: "",
    secondary_phone: null,
    show_battery: true,
    show_engine_load: true,
    show_engine_rpm: true,
    show_engine_temp: true,
    show_fuel_consumption: true,
    show_fuel_level: true,
    show_location: true,
    show_mileage: true,
    show_speed: true,
    show_throttle_position: true,
    show_voltage: true,
    sos_email: false,
    sos_notification: true,
    sos_notification_global: true,
    sos_sms: false,
    speed_email: true,
    speed_limit: "",
    speed_notification: true,
    speed_notification_global: true,
    speed_sms: true,
    tow_email: true,
    tow_notification: true,
    tow_notification_global: true,
    tow_sms: true,
    trip_coordinate: true,
    trip_email: false,
    trip_end_timer: "",
    trip_notification: false,
    trip_notification_global: true,
    trip_sensor: false,
    trip_sms: false,
    vehicle_color: null,
    vehicle_type: "car",
    zone_alert_notification: true,
  },
  odometer_value: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TO_MOVETOACTIVATION":
      return {
        ...state,
        movetoactivationpage: action.movetoactivationpage,
      };
    case "ADD_TO_MOVETOPAYMENT":
      return {
        ...state,
        movetopaymentpage: action.movetopaymentpage,
      };
    case "ADD_TO_MOVETOTERMS":
      return {
        ...state,
        movetotermspage: action.movetotermspage,
      };
    case "ADD_TO_MOVETOCONFIRM":
      return {
        ...state,
        movetoconfirmpage: action.movetoconfirmpage,
      };
    case "ADD_TO_TOPBARNAVIGATION":
      return {
        ...state,
        shownavigationthroughtopbar: action.shownavigationthroughtopbar,
      };
    case "ADD_TO_COUNTRY":
      return {
        ...state,
        countries: action.countries,
      };
    case "ADD_TO_STATE":
      return {
        ...state,
        states: action.states,
      };
    case "ADD_TO_TIMEZONE":
      return {
        ...state,
        timezone: action.timezone,
      };
    case "ADD_TO_SERVICEPROVIDER":
      return {
        ...state,
        serviceProvider: action.serviceProvider,
      };
    case "ADD_TO_SERVICERULES":
      return {
        ...state,
        servicerules: action.servicerules,
      };
    case "ADD_TO_SERVICEPLAN":
      return {
        ...state,
        servicePlan: action.servicePlan,
      };
    case "ADD_TO_SERVICEPLAN_GPS":
      return {
        ...state,
        servicePlanGPS: action.servicePlan,
      };
    case "ADD_TO_DISCOUNT_QUARTER":
      return {
        ...state,
        discount_quarter: action.discount_quarter,
      };
    case "ADD_TO_DISCOUNT_YEARLY":
      return {
        ...state,
        discount_yearly: action.discount_yearly,
      };
    case "ADD_TO_CUSTOMERINFORMATION":
      return {
        ...state,
        customerInformation: action.customerInformation,
      };
    case "ADD_TO_ACTIVATIONTYPE":
      return {
        ...state,
        activationType: action.activationType,
      };
    case "ADD_TO_PAYMENTMETHOD":
      return {
        ...state,
        paymentMethod: action.paymentMethod,
      };
    case "ADD_TO_TERMS":
      return {
        ...state,
        terms: action.terms,
      };
    case "ADD_TO_USEREXIST":
      return {
        ...state,
        userexists: action.userexists,
      };
    case "ADD_TO_DEVICESETTINGS":
      return {
        ...state,
        devicesetting: action.devicesetting,
      };
    case "ADD_TO_DEVICESETTINGS_GPS":
      return {
        ...state,
        devicesettinggps: action.devicesetting,
      };
    case "ADD_TO_GLOBALALERT":
      return {
        ...state,
        globalalert: action.globalalert,
      };
    case "ADD_TO_ODOMETERVALUE":
      return {
        ...state,
        odometer_value: action.odometer_value,
      };
    default:
      return state;
  }
};

export default reducer;
